import React from 'react';
import { Container } from 'react-bootstrap';
import MarketingHeader from './MarketingHeader';
import ELearningHeader from '../Dashboard/ELearning/Sections/ELearningHeader';
import MarketingVideoPlayer from './MarketingVideoPlayer';
import configData from '../../config.json';
import { demoModuleDetail } from './marketingDemoData';
import '../Dashboard/ELearning/Sections/ExtraSection.css';
import '../Dashboard/ELearning/Sections/Watch.css';
import '../Dashboard/ELearning/Sections/ELearningHeader.css';
import './MarketingAssets.css';

/** Static V1 e-learning lesson page for marketing captures. */
const MarketingLessonPreview = ({
    showHeader = true,
    embedded = false,
    compact = false,
    moduleDetail = demoModuleDetail,
}) => {
    const allState = { ModuleInfo: moduleDetail };
    const watchSection = moduleDetail.sections.find((x) => x.name === 'Watch');

    const watchMarkup = watchSection?.contentText
        ? { __html: watchSection.contentText }
        : { __html: '' };

    return (
        <div
            className={`marketing-v1-shell marketing-lesson${
                embedded ? ' marketing-lesson--embedded' : ''
            }${compact ? ' marketing-lesson--compact' : ''}`.trim()}
            style={{ height: '100%', backgroundColor: '#f5f5f5' }}
        >
            {showHeader ? (
                <div style={{ backgroundColor: 'white' }}>
                    <MarketingHeader />
                </div>
            ) : null}
            <Container fluid>
                {compact ? (
                    <div className="marketing-lesson__compact-header">
                        <p className="marketing-lesson__compact-caption">
                            {moduleDetail.caption}
                        </p>
                        <h2 className="marketing-lesson__compact-title">
                            {moduleDetail.title}
                        </h2>
                    </div>
                ) : (
                    <ELearningHeader
                        AllState={allState}
                        configData={configData}
                        isModuleCertification={false}
                    />
                )}
                {watchSection ? (
                    <Container fluid className="watch_container">
                        <div className="watchHeader_container">
                            <div className="WatchTitle">
                                <h5>
                                    <label>{watchSection.title}</label>
                                    <br />
                                    {' '}
                                    PROGRESS{' '}
                                    <span style={{ color: '#78ccf6' }}>1/3</span>
                                </h5>
                            </div>
                            <div className="watchHeader_wrapper">
                                <div className="watch__modules">
                                    <div className="watchTitle__modules">
                                        <div
                                            className="WatchDesc"
                                            dangerouslySetInnerHTML={watchMarkup}
                                        />
                                    </div>
                                    <div className="marketing-lesson__video-wrap">
                                        <MarketingVideoPlayer
                                            url={watchSection.videoUrl}
                                            title={moduleDetail.title}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lineBottomWatch" />
                    </Container>
                ) : null}
            </Container>
        </div>
    );
};

export default MarketingLessonPreview;
